export const EUROPALLET_DIMENSIONS = {
  length: 120,
  width: 80,
} as const;
